export const variables = {
  colors: {
    primary   : '#34AEFF',
    secondary : '#0063A5',
    white     : '#FFFFFF',
    black     : '#101010',
    gray      : '#525252',
    lightGray : '#F0F0F0',
    darkGray  : '#727272',
    green     : '#019618',
    blue      : '#4091F7',
    red       : '#C1272D',
    darkRed   : '#8C090E',
    lightRed  : '#FF0000',
    lightBlue : '#E0F3FF',
  },
  spacing: {
    xs   : '10px',
    sm   : '18px',
    md   : '24px',
    lg   : '30px',
    xl   : '40px',
    xxl  : '68px',
    xxxl : '82px',
  },
};
